import { render, staticRenderFns } from "./DVideoGetLinksBox.vue?vue&type=template&id=57350b86&scoped=true&"
import script from "./DVideoGetLinksBox.vue?vue&type=script&lang=js&"
export * from "./DVideoGetLinksBox.vue?vue&type=script&lang=js&"
import style0 from "./DVideoGetLinksBox.vue?vue&type=style&index=0&id=57350b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57350b86",
  null
  
)

export default component.exports